import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 640;
const TABLET_BREAKPOINT = 1024;

export const useDeviceType = () => {
    const getDevice = () => {
        const width = window.innerWidth;

        if (width <= MOBILE_BREAKPOINT) {
            return "mobile";
        }
        if (width <= TABLET_BREAKPOINT) {
            return "tablet";
        }
        return "desktop";
    };

    const [device, setDevice] = useState(getDevice);

    useEffect(() => {
        const onResize = () => {
            setDevice(getDevice());
        };

        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    return {
        isMobile: device === "mobile",
        isTablet: device === "tablet",
        isDesktop: device === "desktop",
        device
    };
};
